import { render, staticRenderFns } from "./Troubleshoot.vue?vue&type=template&id=c28da3e4"
import script from "./Troubleshoot.vue?vue&type=script&lang=js"
export * from "./Troubleshoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports